import { OPPORTUNITY_REPORTS_REQUEST, OPPORTUNITY_REPORTS_SUCSSES } from './dashboardSavedsearchReportsData.actions';
import { DashboardSavedsearchReportsState, DashboardSavedsearchReportsModels } from './dashboardSavedsearchReportsData.state';
import { Action as NgRxAction } from '@ngrx/store'
import { getDashboardSavedsearchReportsdData } from './dashboardSavedsearchReportsData.compare';

export interface Action extends NgRxAction {
  payload?: DashboardSavedsearchReportsModels
}

const initialDashboardSavedsearchReportsState: DashboardSavedsearchReportsState = {
  dashboardSavedsearchReports: []
}

export function DashboardSavedsearchReportsReducer(state = initialDashboardSavedsearchReportsState, action: Action): DashboardSavedsearchReportsState {

  switch (action.type) {
    case OPPORTUNITY_REPORTS_REQUEST: {
      return { ...state };
    }
    case OPPORTUNITY_REPORTS_SUCSSES: {
      const results = getDashboardSavedsearchReportsdData(state.dashboardSavedsearchReports, action.payload.reportType, action.payload.addedFilters);

      if (results.index > -1) {
        state.dashboardSavedsearchReports[results.index] = action.payload;
      } else {
        state.dashboardSavedsearchReports.push(action.payload);
      }

      return { ...state };
    }
    default: {
      return state;
    }
  }
}
